/* eslint-disable react/prop-types */
/* eslint-disable arrow-body-style */
import { useShallow } from 'zustand/shallow';
import Text from '../../assets/styles/Text';
import { useStore } from '../../stores';
import * as styles from './styles'; // Use os mesmos estilos da página Cities

function FilterColumn({ filters, parseChoices }) {
  const { filtersSelect, addFilter, removeFilter } = useStore(
    useShallow((state) => ({
      filtersSelect: state.filtersSelect,
      addFilter: state.addFilter,
      removeFilter: state.removeFilter,
    }))
  );

  const isFilterActive = (filterId, choice) => {
    return filtersSelect.includes(`${filterId}-${choice}`);
  };

  const handleToggleFilter = (filterId, choice, isMultiple) => {
    const filterKey = `${filterId}-${choice}`;
    const isActive = filtersSelect.includes(filterKey);

    // Se não for múltiplo, remove outros do mesmo tipo
    if (!isMultiple) {
      const currentFiltersOfSameType = filtersSelect.filter((item) =>
        item.startsWith(`${filterId}-`)
      );

      currentFiltersOfSameType.forEach((item) => {
        if (item !== filterKey) {
          removeFilter(item);
        }
      });
    }

    // Toggle
    if (isActive) {
      removeFilter(filterKey);
    } else {
      addFilter(filterKey);
    }
  };

  const handleToggleChildFilter = (filterId, childName, allOptions) => {
    const filterKey = `${filterId}-${childName}`;

    // Remove outros (comportamento exclusivo)
    allOptions.forEach((opt) => {
      const optKey = `${opt.id}-${opt.name}`;
      if (optKey !== filterKey && filtersSelect.includes(optKey)) {
        removeFilter(optKey);
      }
    });

    // Toggle atual
    if (filtersSelect.includes(filterKey)) {
      removeFilter(filterKey);
    } else {
      addFilter(filterKey);
    }
  };

  if (!Array.isArray(filters) || filters.length === 0) return null;

  return (
    <>
      {filters.map((filter) => {
        const choices = parseChoices(filter.choices);
        const hasChildren =
          Array.isArray(filter.children) && filter.children.length > 0;
        const isMultiple = filter.multiple === true;

        // Filtros com children
        if (hasChildren) {
          const allOptions = [filter, ...filter.children];

          return (
            <styles.FilterGroup key={filter.id}>
              <Text.P>{filter.name}</Text.P>
              <styles.ButtonGroup $wrap={allOptions.length > 2}>
                {allOptions.map((option) => {
                  const isActive = isFilterActive(option.id, option.name);

                  return (
                    <styles.FilterButton
                      key={option.id}
                      $isActive={isActive}
                      onClick={() =>
                        handleToggleChildFilter(
                          option.id,
                          option.name,
                          allOptions
                        )
                      }
                      type="button"
                    >
                      <Text.P>{option.name}</Text.P>
                    </styles.FilterButton>
                  );
                })}
              </styles.ButtonGroup>
            </styles.FilterGroup>
          );
        }

        // Filtros com choices
        if (choices.length > 0) {
          return (
            <styles.FilterGroup key={filter.id}>
              <Text.P>
                {filter.name}
                {!isMultiple && (
                  <span className="single-select-hint">(apenas um)</span>
                )}
              </Text.P>
              <styles.ButtonGroup $wrap={choices.length > 2}>
                {choices.map((choice) => {
                  const isActive = isFilterActive(filter.id, choice);

                  return (
                    <styles.FilterButton
                      key={choice}
                      $isActive={isActive}
                      onClick={() =>
                        handleToggleFilter(filter.id, choice, isMultiple)
                      }
                      type="button"
                    >
                      <Text.P>{choice}</Text.P>
                    </styles.FilterButton>
                  );
                })}
              </styles.ButtonGroup>
            </styles.FilterGroup>
          );
        }

        return null;
      })}
    </>
  );
}

export default FilterColumn;
